/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* React Boostrap */
import CustomizedTooltip from "../../components/CustomizedTooltip"
import BplsInformationsIcon from "../../components/atoms/icons/BplsInformationsIcon"
import BplsSignatureIcon from "../../components/atoms/icons/BplsSignatureIcon"
import BplsTimeIcon from "../../components/atoms/icons/BplsTimeIcon"
import Footer from "../../components/main/Footer"

/* Components */
import { TENANTS } from "../../constants"
import { initPdiComponent } from "../../core/service/BusinessLogicService"

/* Utils */
import { loc } from "../../core/utils"
import { shape } from "prop-types"
import React, { Component } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { Topbar } from "../../components/organisms/Topbar"

const Components = {
  BplsInformationsIcon,
  BplsTimeIcon,
  BplsSignatureIcon
}
class OnboardingPage extends Component {
  state = {}

  componentDidMount() {
    initPdiComponent("OnBoardingPage")
  }

  render() {
    const { tunnelData } = this.props
    const { tenant } = tunnelData
    return (
      <Container fluid>
        <Row noGutters>
          <Col className="misc-block">
            <Row>
              <Topbar tunnelData={this.props?.tunnelData} history={this.props?.history} displayToggleButton={false}/>
              <Col sm={12}>
                {/* CONTENT */}
                <Container className="onboarding-container container-wider">
                  <Row className="justify-content-center">
                    <Col lg={9} className="text-center">
                      {this.props.tunnelData.onBoardingFirstSubtitle.map((subtitlePart, index) => {
                        if (index === 0) {
                          return (
                            <h1 key={subtitlePart} data-cy="heading1">
                              {loc(subtitlePart)}
                            </h1>
                          )
                        } else {
                          return <p key={subtitlePart}>{loc(subtitlePart)}</p>
                        }
                      })}
                    </Col>
                  </Row>
                  <Row className="block-steps">
                    {this.props?.tunnelData.breadcrumbs.map((step, index) => {
                      if (step.title && step.description) {
                        return (
                          <Col key={index} sm={12} md={true} className="block-step hard-shadow-white-block text-center">
                            <h3>{loc(step.title)}</h3>
                            <p>{index === 1 && tenant === TENANTS.CONFORAMA ? "" : loc(step.description)}</p>
                            {step?.iconName &&
                              React.createElement(Components[step?.iconName], {
                                fill: tunnelData?.brandColor,
                                height: "3rem",
                                width: "3rem",
                                style: { margin: 30 }
                              })}
                          </Col>
                        )
                      } else {
                        return null
                      }
                    })}
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <h3>{loc(this.props.tunnelData.onBoardingSecondSubtitle)}</h3>
                    </Col>
                  </Row>
                  <Row className="justify-content-center text-center onboarding-documents">
                    {this.props?.tunnelData.onBoardingDocuments.map((document, index) => (
                      <Col xs={6} md={2} key={index}>
                        <CustomizedTooltip document={document} isParagraphed={true} />
                      </Col>
                    ))}
                  </Row>
                  <Row className="footer-fixed">
                    <Col
                      lg={{ span: 3, order: 1 }}
                      md={{ span: 4, order: 1 }}
                      xs={{ span: 12, order: 2 }}
                      className="mr-auto"
                    >
                      <Button
                        href={this.props?.tunnelData?.shopUrl}
                        variant="outline-primary"
                        className="ico-back-small-before"
                      >
                        {tenant === TENANTS.BPLS ? loc`Back to basket` : loc`Back to shop`}
                      </Button>
                    </Col>
                    <Col
                      lg={{ span: 3, order: 2 }}
                      md={{ span: 4, order: 2 }}
                      xs={{ span: 12, order: 1 }}
                      className="align-item-end"
                    >
                      <Button
                        id="continue-button"
                        variant="success"
                        className="btn-solid btn"
                        disabled={this.state?.paymentButtonLocked === true}
                        onClick={() => this.onValidate()}
                      >
                        {tenant === TENANTS.BPLS ? loc("bpls_onboarding_validation_button") : loc`Start`}
                      </Button>
                    </Col>
                  </Row>
                </Container>
                {/* END CONTENT */}
              </Col>

              <Col sm={12}>
                <Container className="container-wider">
                  <Footer tunnelData={this.props?.tunnelData} />
                </Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }

  onValidate() {
    this.props.onSetStep()
  }
}

OnboardingPage.propTypes = {
  tunnelData: shape({})
}

export default OnboardingPage
